export default __webpack_public_path__ + "static/rafal-bd0c641974e9953d89a2c63443944776.jpg";